import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enAuth from '../locales/en/auth.json';
import enBookkeeping from '../locales/en/bookkeeping.json';
import enCommon from '../locales/en/common.json';
import enErrors from '../locales/en/errors.json';
import enSettings from '../locales/en/settings.json';
import esAuth from '../locales/es/auth.json';
import esBookkeeping from '../locales/es/bookkeeping.json';
import esCommon from '../locales/es/common.json';
import esErrors from '../locales/es/errors.json';
import esSettings from '../locales/es/settings.json';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    interpolation: { escapeValue: false },
    resources: {
      es: {
        common: esCommon,
        auth: esAuth,
        settings: esSettings,
        errors: esErrors,
        bookkeeping: esBookkeeping,
      },
      en: {
        common: enCommon,
        auth: enAuth,
        settings: enSettings,
        errors: enErrors,
        bookkeeping: enBookkeeping,
      },
    },
    // ES is the default per Phase 2 design — EN is opt-in via switcher.
    // Don't sniff navigator.language so a Spanish-speaking user on an
    // English-locale browser still lands on the Spanish UI by default.
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'lang',
    },
  });

export default i18n;
